import axios from 'axios'
import qs from 'qs'
import { Get, Post} from './http.js'

/**
 * @name  获取手机验证码
 * @param {appType:'znz',mobile,version} params 
 */

export const gainCode = (params) => Get(params, '/user/gainCode.do');

/**
  * @name  验证验证码
  * @param {usermobile,userpassword} params 
  */
export const login = (params) => Get(params, '/user/login.do');

/**
  * @name  获取公司列表
  * @param {organizationId,userId,version} params 
  */
export const gainOrganizationList = (params) => Get(params, '/user/gainOrganizationList.do');

/**
  * @name  获取用户信息
  * @param {organizationId,userId,version} params 
  */
export const gainUserInfo = (params) => Get(params, '/user/gainUserInfo.do');

/**
  * @name  获取VIP信息
  * @param {organizationId,userId,version} params 
  */
export const gainVipInfo = (params) => Get(params, '/set/gainVipInfo.do');

/**
  * @name  注册新用户
  * @param {companyName,mobile,userName,code,cityCode,appType="znz",version} params 
  */
 export const regitsterNew = (params) => Get(params, '/user/regitsterNew.do');




/*--------------------------------------home页的接口----------------------------------------- */

/**
 * @name  获取项目列表 (order:0 按时间由高到低 2 按时间由低到高  1 按完成度由高到低； 3 按完成度由低到高； isSign:0 未签约;1 已签约；2全部， isSpecial:false 标识是否是特殊情况（比如是成员列表）
 * @param {organizationId,userId,version,pageNum,pageSize,order,isSpecial,isSign} params 
 * 
 */
export const getProjectList = (params) => Get(params, '/project/showProject.do');

/**
  * @name  获取下拉成员
  * @param {organizationId,userId,version} params 
  */
export const gainIndexUser = (params) => Get(params, '/v2/set/gainIndexUser.do');

/**
  * @name  获取项目节点列表
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectSchedule = (params) => Get(params, '/project/gainProjectSchedule.do');

/**
  * @name  获取项目节点详情
  * @param {organizationId,userId,version,projectId,projectScheduleId} params 
  */
export const gainProjectScheduleDetail = (params) => Get(params, '/v2/set/gainProjectScheduleDetail.do');

/**
  * @name  修改项目节点名称
  * @param {organizationId,userId,version,projectId,scheduleName,scheduleId} params 
  */
export const editProjectScheduleName = (params) => Get(params, '/v4/project/editProjectScheduleName.do');

/**
 * @name  修改项目节点完成状态
 * @param {organizationId,userId,version,projectId,projectScheduleId,status} params 
 */
export const setProjectScheduleState = (params) => Get(params, '/project/setProjectScheduleState.do');

/**
  * @name  修改项目节点计划完成时间
  * @param {organizationId,userId,version,projectId,projectScheduleId,scheduleTime,isCascade} params 
  */
export const setProjectScheduleTimeV3 = (params) => Get(params, '/v4/project/setProjectScheduleTimeV3.do');

/**
  * @name  获取负责人列表
  * @param {organizationId,userId,version,projectId,projectScheduleId,scheduleTime,isCascade} params 
  */
export const editProjectNotifyMember = (params) => Get(params, '/project/editProjectNotifyMember.do');

/**
  * @name  设置项目进度延期提醒(负责人)
  * @param {organizationId,userId,version,projectScheduleId,notifyUserIds} params 
  */
export const setProjectNotifyMember = (params) => Get(params, '/project/setProjectNotifyMember.do');

/**
  * @name  上传项目节点的相关照片
  * @param {organizationId,userId,version,projectId,id,photo} params 
  */
export const addProjectScheduleOssPhoto = (params) => Get(params, '/project/addProjectScheduleOssPhoto.do');

/**
  * @name  上传项目节点的相关视频
  * @param {organizationId,userId,version,projectId,id,video} params 
  */
 export const addProjectScheduleOssVideo = (params) => Get(params, '/project/addProjectScheduleOssVideo.do');

/**
  * @name  修改进度注意事项
  * @param {organizationId,userId,version,projectId} params 
  */
 export const setProjectScheduleText = (params) => Post(params, '/v2/project/setProjectScheduleText.do');





 


/**
  * @name  获取项目基本信息
  * @param {organizationId,userId,version,projectId} params 
  */
export const showProjectDetail = (params) => Get(params, '/project/showProjectDetail.do');

/**
  * @name  获取项目信息首页基础信息
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectIndexData = (params) => Get(params, '/v2/set/gainProjectIndexData.do');

/**
  * @name  获取项目收藏状态
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainMyCollectStatus = (params) => Get(params, '/user/gainMyCollectStatus.do');

/**
  * @name  修改项目收藏状态
  * @param {organizationId,userId,version,projectId} params 
  */

export const switchMyCollect = (params) => Get(params, '/user/switchMyCollect.do');


/**
  * @name  删除该项目
  * @param {organizationId,userId,version,projectId} params 
  */

export const delProject = (params) => Get(params, '/project/delProject.do');





/**
  * @name  签约状态重设
  * @param {organizationId,userId,version,projectId} params 
  */
export const resetSignedTime = (params) => Get(params, '/project/resetSignedTime.do');

/**
  * @name  选择签约时间
  * @param {organizationId,userId,version,projectId,signedTime(格式：2019-06-25)} params 
  */
export const setSignedTime = (params) => Get(params, '/project/setSignedTime.do');

/**
  * @name  选择完工状态
  * @param {organizationId,userId,version,projectId,overTime(2019-06-25)} params 
  */
export const setCompleteTime = (params) => Get(params, '/project/setCompleteTime.do');



/**
 * @name  完工状态重设
 * @param {organizationId,userId,version,projectId} params 
 */
export const resetCompleteTime = (params) => Get(params, '/project/resetCompleteTime.do');

/**
  * @name  添加项目业主信息
  * @param {organizationId,userId,version,projectId,masterName,mobile,isLogin(1)} params 
  */
export const saveProjectMaster = (params) => Get(params, '/project/saveProjectMaster.do');

/**
 * @name  编辑项目业主信息
 * @param {organizationId,userId,version,projectId,masterId,masterName,mobile,isLogin(1)} params 
 */
export const editProjectMaster = (params) => Get(params, '/project/editProjectMaster.do');


/**
  * @name 删除业主信息
  * @param {organizationId,userId,version,projectId,masterId} params 
  */
export const delProjectMaster = (params) => Get(params, '/project/delProjectMaster.do');

/**
  * @name 修改项目地址
  * @param {organizationId,userId,version,projectId,projectName} params 
  */
export const editProject = (params) => Get(params, '/project/editProject.do');

/**
  * @name 修改装修面积
  * @param {organizationId,userId,version,projectId,area} params 
  */
export const editArea = (params) => Get(params, '/project/editArea.do');

/**
 * @name 修改渠道来源
 * @param {organizationId,userId,version,projectId,channelSourceName} params 
 */
export const setChannelSource = (params) => Get(params, '/project/setChannelSource.do');

/**
 * @name 修改装修类型
 * @param {organizationId,userId,version,projectId,decorationId} params 
 */
export const setProjectDecorateType = (params) => Get(params, '/project/setProjectDecorateType.do');

/**
  * @name  获取项目成员
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectMember = (params) => Get(params, '/project/gainProjectMember.do');

/**
 * @name  修改非管理员的内控权限
 * @param {organizationId,userId,version,projectId,sUserId,oper} params 
 */
export const setProjectVisible = (params) => Get(params, '/v2/set/setProjectVisible.do');

/**
* @name  获取调整成员列表
* @param {organizationId,userId,version,projectId} params 
*/
export const editProjectMember = (params) => Get(params, '/project/editProjectMember.do');

/**
  * @name  添加项目成员
  * @param {organizationId,userId,version,projectId,organizationUserIds} params 
  */
export const addProjectMember = (params) => Get(params, '/project/addProjectMember.do');

/**
  * @name  初始化自动排期
  * @param {organizationId,userId,version,projectId,startTime} params 
  */
export const projectAutoSchedule = (params) => Get(params, '/v4/project/projectAutoSchedule.do');

/**
  * @name  获取内部备忘录
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectBoard = (params) => Get(params, '/project/gainProjectBoard.do');

/**
  * @name  获取业主内部备忘录
  * @param {organizationId,userId,version,projectId} params 
  */
 export const gainYZProjectBoard = (params) => Get(params, '/yz/project/gainProjectBoard.do');


/**
  * @name  添加内部备忘录
  * @param {organizationId,userId,version,projectId,replyId,content,notifyUserIds} params 
  */
export const addProjectBoard = (params) => Post(params, '/project/addProjectBoard.do');


/**
  * @name  添加业主内部备忘录
  * @param {organizationId,userId,version,projectId,replyId,content,notifyUserIds} params 
  */
 export const addYZProjectBoard = (params) => Post(params, '/yz/project/addProjectBoard.do');


/**
 * @name  添加内部备忘录图片
 * @param {organizationId,userId,version,projectId,id,photo} params 
 */
export const addProjectBoardOssAttachment = (params) => Post(params, '/project/addProjectBoardOssAttachment.do');

/**
 * @name  添加业主内部备忘录图片
 * @param {organizationId,userId,version,projectId,id,photo} params 
 */
export const addYZProjectBoardOssAttachment = (params) => Post(params, '/yz/project/addProjectBoardOssAttachment.do');

/**
 * @name  删除内部备忘录项
 * @param {organizationId,userId,version,projectId,projectBoardId} params 
 */
export const delProjectBoard = (params) => Get(params, '/project/delProjectBoard.do');

/**
 * @name  删除业主内部备忘录项
 * @param {organizationId,userId,version,projectId,projectBoardId} params 
 */
export const delYZProjectBoard = (params) => Get(params, '/yz/project/delProjectBoard.do');


/**
  * @name  获取项目合同款项明细列表
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectContract = (params) => Get(params, '/v2/set/gainProjectContract.do');

/**
 * @name  获取项目合同款项照片
 * @param {organizationId,userId,version,projectId,photo,id} params 
 */
export const addProjectContractOssPhoto = (params) => Post(params, '/project/addProjectContractOssPhoto.do');

/**
* @name  更改项目合同款项
* @param {organizationId,userId,version,projectId,money,projectContractId} params 
*/
export const setProjectContractMoney = (params) => Get(params, '/project/setProjectContractMoney.do');

/**
* @name  获取项目收款状态明细
* @param {organizationId,userId,version,projectId} params 
*/
export const gainProjectFund = (params) => Get(params, '/v2/set/gainProjectFund.do');

/**
 * @name  添加项目应收金额照片
 * @param {organizationId,userId,version,projectId,id,photo} params 
 */
export const addProjectGatheringNeedOssPhoto = (params) => Post(params, '/v2/set/addProjectGatheringNeedOssPhoto.do');

/**
  * @name  添加项目已收金额照片
  * @param {organizationId,userId,version,projectId,id,photo} params 
  */
export const addProjectGatheringReceivablesOssPhoto = (params) => Post(params, '/v2/set/addProjectGatheringReceivablesOssPhoto.do');

/**
  * @name  设置项目已收金额
  * @param {organizationId,userId,version,projectId,projectGatherId,receivables} params 
  */
export const setProjectGatheringReceivablesMoney = (params) => Post(params, '/v2/set/setProjectGatheringReceivablesMoney.do');


/**
  * @name  设置项目应收金额
  * @param {organizationId,userId,version,projectId,projectGatherId,totalMoney} params 
  */
export const setProjectGatheringNeedMoney = (params) => Post(params, '/v2/set/setProjectGatheringNeedMoney.do');


/**
* @name  获取增减项列表
* @param {organizationId,userId,version,projectId} params 
*/
export const gainMoreOrLess = (params) => Get(params, '/v2/set/gainMoreOrLess.do');

/**
  * @name  添加增减项
  * @param {organizationId,userId,version,projectId,moreOrLess,money,photo} params 
  */
export const addMoreOrLess = (data) => Post(data, '/v2/set/addMoreOrLess.do');

/**
  * @name  删除增减项
  * @param {organizationId,userId,version,projectId,id} params 
  */
export const delMoreOrLess = (data) => Post(data, '/v2/set/delMoreOrLess.do');


/**
  * @name  获取建材支出列表
  * @param {organizationId,userId,version,projectId} params 
  */
export const showSupplyMaterialBrand = (params) => Get(params, '/v3/project/showSupplyMaterialBrand.do');


/**
  * @name  获取建材支出设置限额（缓存的）
  * @param {organizationId,userId,version,projectId} params 
  */
export const getProjectMaterialTypeLimit = (params) => Get(params, '/v2/project/getProjectMaterialTypeLimit.do');

/**
  * @name  设置建材支出限额
  * @param {organizationId,userId,version,projectId,materialsLimit} params 
  */
export const setProjectMaterialTypeLimit = (params) => Get(params, '/v2/project/setProjectMaterialTypeLimit.do');

/**
 * @name  根据建材名称模糊匹配已有建材
 * @param {organizationId,userId,version,brandName,} params 
 */
export const matchingMaterials = (params) => Get(params, '/v2/set/matchingMaterials.do');

/**
  * @name  根据建材id获取相关信息
  * @param {organizationId,userId,version,projectId,organizationMaterialsBrandId} params 
  */
export const gainMaterialsBrandById = (params) => Get(params, '/v2/set/gainMaterialsBrandById.do');

/**
 * @name  添加建材支出
 * @param {organizationId,userId,version,projectId,expenseTypeId,materialsBrandName,supplyPrice,supplyNum,unit,remark,photo} params 
 */
export const addSupplyMaterialBrand = (params) => Post(params, '/v3/project/addSupplyMaterialBrand.do');

/**
  * @name  编辑建材支出
  * @param {organizationId,userId,projectId,version,materialsBrandId,materialsTypeId,supplyPrice,supplyNum,unit,remark,photo,supplyId} params 
  */
export const updateSupplyMaterialBrand = (params) => Post(params, '/v2/set/updateSupplyMaterialBrand.do');

/**
* @name  获取建材支出详情
* @param {organizationId,userId,version,projectId,supplyId} params 
*/
export const gainSupplyMaterialBrandDetail = (params) => Post(params, '/v2/set/gainSupplyMaterialBrandDetail.do');

/**
* @name  删除建材支出
* @param {organizationId,userId,version,projectId,supplyId} params 
*/
export const delSupplyMaterialBrand = (params) => Post(params, '/v2/set/delSupplyMaterialBrand.do');



/**
  * @name  获取人工支出列表
  * @param {organizationId,userId,version,projectId} params 
  */
export const showProjectWorkerExpense = (params) => Get(params, '/v3/project/showProjectWorkerExpense.do');

/**
* @name  获取人工支出限额列表
* @param {organizationId,userId,version,projectId} params 
*/
export const getWorkerExpenseLimit = (params) => Get(params, '/v3/project/getWorkerExpenseLimit.do');

/**
  * @name  设置工人支出限额
  * @param {organizationId,userId,version,projectId,workExpenseLimit} params 
  */
export const setWorkerExpenseLimit = (params) => Get(params, '/v3/project/setWorkerExpenseLimit.do');

/**
  * @name  添加水电支出记录
  * @param {organizationId,userId,version,projectId,name,money,appType,photo,remark} params 
  */
export const addWaterElectricityRecord = (params) => Get(params, '/v2/set/addWaterElectricityRecord.do');

/**
 * @name  添加泥瓦支出记录
 * @param {organizationId,userId,version,projectId,name,money,appType,photo,remark} params 
 */
export const addMudRecord = (params) => Get(params, '/v2/set/addMudRecord.do');

/**
* @name  添加木作支出记录
* @param {organizationId,userId,version,projectId,name,money,appType,photo,remark} params 
*/
export const addWoodRecord = (params) => Get(params, '/v2/set/addWoodRecord.do');

/**
* @name  添加油漆支出记录
* @param {organizationId,userId,version,projectId,name,money,appType,photo,remark} params 
*/
export const addPaintRecord = (params) => Get(params, '/v2/set/addPaintRecord.do');


/**
 * @name  获取其他支出记录信息
 * @param {organizationId,userId,version,projectId} params 
 */
export const showOtherRecord = (params) => Get(params, '/v2/set/showOtherRecord.do');

/**
 * @name  添加其他支出记录信息
 * @param {organizationId,userId,version,projectId,name,money,photo} params 
 */
export const addOtherRecord = (params) => Get(params, '/v2/set/addOtherRecord.do');

/**
 * @name  修改其他支出记录信息
 * @param {organizationId,userId,version,projectId,name,money,photo,recordId} params 
 */
export const updateWorkRecord = (params) => Get(params, '/v2/set/updateWorkRecord.do');

/**
 * @name  删除其他支出记录信息
 * @param {organizationId,userId,version,projectId,name,money,photo,recordId} params 
 */
export const delWorkRecord = (params) => Get(params, '/v2/set/delWorkRecord.do');

/**
  * @name  设置其他支出限额
  * @param {organizationId,userId,version,projectId,limitOther} params 
  */
export const setOtherLimit = (params) => Get(params, '/v2/set/setOtherLimit.do');

/**
  * @name  获取项目操作日志
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectHistory = (params) => Get(params, '/user/gainProjectHistory.do');

/**
  * @name  获取项目写真照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainScenePhoto = (params) => Get(params, '/v3/set/gainScenePhoto.do');

/**
  * @name  修改项目写真照片
  * @param {organizationId,userId,version,projectId,scenePhoto} params 
  */
export const updateScenePhoto = (data) => Post(data, '/v3/set/updateScenePhoto.do');

/**
  * @name  装修合同照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectContractPhoto = (params) => Get(params, '/v2/set/gainProjectContractPhoto.do');

/**
  * @name  修改装修合同照片
  * @param {organizationId,userId,version,projectId,contractPhoto} params 
  */
export const updateProjectContractPhoto = (data) => Post(data, '/v2/set/updateProjectContractPhoto.do');

/**
  * @name  设计图照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectDesignPhoto = (params) => Get(params, '/v2/set/gainProjectDesignPhoto.do');

/**
  * @name  修改设计图照片
  * @param {organizationId,userId,version,projectId,designPhoto} params 
  */
export const updateProjectDesignPhoto = (data) => Post(data, '/v2/set/updateProjectDesignPhoto.do');

/**
  * @name  预算清单照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectBudgetPhoto = (params) => Get(params, '/v2/set/gainProjectBudgetPhoto.do');

/**
  * @name  修改预算清单照片
  * @param {organizationId,userId,version,projectId,budgetPhoto} params 
  */
export const updateProjectBudgetPhoto = (data) => Post(data, '/v2/set/updateProjectBudgetPhoto.do');

/**
  * @name  材料清单照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainProjectMaterialsPhoto = (params) => Get(params, '/v2/set/gainProjectMaterialsPhoto.do');

/**
 * @name  修改材料清单照片
 * @param {organizationId,userId,version,projectId,materialsPhoto} params 
 */
export const updateMaterialsPhoto = (data) => Post(data, '/v2/set/updateMaterialsPhoto.do');

/**
  * @name  水电照片
  * @param {organizationId,userId,version,projectId} params 
  */
export const gainWaterElectricityPhoto = (params) => Get(params, '/v2/set/gainWaterElectricityPhoto.do');

/**
 * @name  修改水电照片
 * @param {organizationId,userId,version,projectId,waterElectricityPhoto} params 
 */
export const updateWaterElectricityPhoto = (data) => Post(data, '/v2/set/updateWaterElectricityPhoto.do');




/**
 * @name  获取项目签到记录v1
 * @param {organizationId,userId,version,startTime,endTime} params 
 */
export const gainProjectSignedv1 = (params) => Get(params, '/sign/gainProjectSigned.do');

/**
 * @name  获取定位状态
 * @param {organizationId,userId,version,projectId} params 
 */
export const gainSignState = (params) => Get(params, '/sign/gainSignState.do');

/**
 * @name  上传签到照片
 * @param {signId,photo} params 
 */
export const uploadProjectSignedPhoto = (params) => Post(params, '/sign/uploadProjectSignedPhoto.do');






/*--------------------------------------find页接口----------------------------------------- */

export const getOrganizationMess = params => {     //-----获取公司消息列表-----//
    return axios({
        url: '/user/gainOrganizationMessage.do',
        method: 'get',
        params   //【organizationId|userId|version|pageNum|pageSize】 
    })
}

export const getOfficemess = params => {     //-----获取官方消息列表-----//
    return axios({
        url: '/user/gainOfficialAndArticleMessage.do',
        method: 'get',
        params   //【organizationId|userId|version|pageNum|pageSize|type】 type：1官方消息 2文章消息
    })
}

export const gainBrandArticle = params => {     //-----获取装企易文章列表-----//
    return axios({
        url: '/v2/user/gainBrandArticleMessage.do',
        method: 'get',
        params   //【organizationId|userId|version|pageNum|pageSize|keyWord|category】
    })
}

export const gainMyCollectArticle = params => {     //-----获取装企易收藏文章列表-----//
    return axios({
        url: '/v2/user/gainMyCollectArticle.do',
        method: 'get',
        params   //【organizationId|userId|version|pageNum|pageSize】
    })
}

export const showArticle = params => {     //-----获取装企易文章内容-----//
    return axios({
        url: '/third/showArticle.do',
        method: 'get',
        params   //【aid】
    })
}

export const collectMyArticle = data => {     //-----收藏|取消文章-----//
    return axios({
        url: '/v2/user/collectMyArticle.do',
        method: 'post',
        data: qs.stringify(data)   //【userId|organizationId|version|messageId】
    })
}


/**
  * @name  获取是否绑定微信
  * @param {organizationId,userId,version} params 
  */
 export const isBindWechat = (params) => Get(params, '/third/isBindWechat.do');







/*--------------------------------------新建项目页接口----------------------------------------- */


// $.ajax({     //添加新项目
//     "url":"http://app.zhuangneizhu.com/project/addProject.do",


/**
  * @name  添加新项目
  * @param {organizationId,userId,version,projectName,templateId} params 
  */
export const addProject = (params) => Get(params, '/project/addProject.do');





/*--------------------------------------member页接口----------------------------------------- */

/**
 * @name  获取公司联系人列表
 * @param {organizationId,userId,version,keyWord} params 
 */
export const gainOrganizationUser = (params) => Get(params, '/v2/set/gainOrganizationUser.do');

/**
 * @name  获取部门信息
 * @param {organizationId,userId,version} params 
 */
export const gainDepartInfo = (params) => Get(params, '/v2/set/gainDepartInfo.do');

/**
 * @name  获取员工角色
 * @param {organizationId,userId,version} params 
 */
export const gainEmployeeType = (params) => Post(params, '/set/gainEmployeeType.do');

/**
 * @name  添加公司联系人
 * @param {organizationId,userId,version,name,mobile,roleName,roleId,departId,isAdmin} params 
 */
export const addContactsInfo = (params) => Get(params, '/user/addContactsInfo.do');

/**
 * @name  删除公司联系人
 * @param {organizationId,userId,version,sUserId} params 
 */
export const delContactsInfo = (params) => Get(params, '/user/delContactsInfo.do');

/**
 * @name  修改公司联系人
 * @param {organizationId,userId,version,sUserId,name,mobile,roleName,roleId,departId,isAdmin,departName} params 
 */
export const editContactsInfo = (params) => Get(params, '/v2/set/editContactsInfo.do');












export const gainIsOrNotAdmin = params => {     //-----判断用户是否管理员-----//
    return axios({
        url: '/user/gainIsOrNotAdmin.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

// my页面

/**
 * @name  获取合同收款确认的总数
 * @param {organizationId,userId,version} params 
 */
export const gainAuditCount = (params) => Get(params, '/v2/set/gainAuditCount.do');





/*--------------------------------------我的项目统计页面----------------------------------------- */

export const projectPie = params => {     //-----获取个人项目总数-----//
    return axios({
        url: '/statistics/my/projectPie.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const projectSignRanking = params => {     //-----获取个人签单量对比-----//
    return axios({
        url: '/statistics/my/projectSignRanking.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const projectSignFund = params => {     //-----获取个人已签约合同收款状态-----//
    return axios({
        url: '/statistics/my/projectSignFund.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const projectChannel = params => {     //-----获取个人项目来源渠道-----//
    return axios({
        url: '/statistics/my/projectChannel.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const projectDecorationType = params => {     //-----个人项目装修类型-----//
    return axios({
        url: '/statistics/my/projectDecorationType.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

/*--------------------------------------公司总统计页面----------------------------------------- */

export const projectPieCom = params => {     //-----获取公司项目总数-----//
    return axios({
        url: '/statistics/company/projectPie.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const signRankingCom = params => {     //-----获取公司个人签单量对比-----//
    return axios({
        url: '/statistics/company/projectSignRanking.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const signFundcom = params => {     //-----获取公司已签约项目收款状态（应收，已收）统计-----//
    return axios({
        url: '/statistics/company/projectSignFund.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const signContractCom = params => {     //-----获取公司已签约合同收款统计-----//
    return axios({
        url: '/statistics/company/projectSignContract.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const channelcom = params => {     //-----获取公司渠道来源统计-----//
    return axios({
        url: '/statistics/company/projectChannel.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const decorationTypecom = params => {     //-----获取公司统计装修类型-----//
    return axios({
        url: '/statistics/company/projectDecorationType.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const expendMoneycom = params => {     //-----获取公司统计建材支出金额-----//
    return axios({
        url: '/statistics/company/projectExpendMoney.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}

export const deptSignRankingcom = params => {     //-----获取公司统计部门签单量-----//
    return axios({
        url: '/statistics/company/projectDeptSignRanking.do',
        method: 'get',
        params   //【organizationId|userId|version|startTime|endTime】
    })
}


/**
 * @name  获取我的个人统计打卡记录
 * @param {organizationId,userId,version,startTime,endTime} params 
 */
export const gainMyClockStatic = (params) => Get(params, '/v2/user/gainMyClockStatic.do');

/**
 * @name  获取我的公司统计打卡记录
 * @param {organizationId,userId,version,startTime,endTime} params 
 */
export const gainCompanyStatic = (params) => Get(params, '/v2/user/gainCompanyStatic.do');


/**
 * @name  获取项目签到记录
 * @param {organizationId,userId,version,startTime,endTime} params 
 */
export const gainProjectSigned = (params) => Get(params, '/sign/gainProjectSigned.do');








/*--------------------------------------我的待办----------------------------------------- */

/**
  * @name 获取待办事项
  * @param {organizationId,userId,version} params 
  */
 export const gainProjectBacklog = (data) => Post(data, '/user/gainProjectBacklog.do');

 /**
  * @name 获取我的延期
  * @param {organizationId,userId,version} params 
  */
 export const gainProjectDelay = (data) => Post(data, '/user/gainProjectDelay.do');

  /**
  * @name 获取公司延期
  * @param {organizationId,userId,version} params 
  */
 export const gainOrganizationDelay = (data) => Post(data, '/user/gainOrganizationDelay.do');

 /**
  * @name 获取公司延期的数量
  * @param {organizationId,userId,version} params 
  */
 export const countProjectDelay = (data) => Post(data,'/project/countProjectDelay.do');



/*--------------------------------------合同收款确认----------------------------------------- */
// fundType 1.已收款;2,应收款；0代表全部
//auditStatus'审核结果(1, "待审核",2, "审核通过",3, "审核不通过"，0，代表全部)'

export const gainContractFundAudit = params => {     //-----获取收款状态列表-----//
    return axios({
        url: '/v2/set/gainContractFundAudit.do',
        method: 'get',
        params   //【organizationId|userId|version|appType:"znz"|pageNum|pageSize|fundType|auditStatus】
    })
}

export const passFundAudit = params => {     //-----审核通过-----//
    return axios({
        url: '/v2/set/passFundAudit.do',
        method: 'get',
        params   //【organizationId|userId|version|auditId】
    })
}

export const ignoreFundAudit = params => {     //-----审核不通过-----//
    return axios({
        url: '/v2/set/ignoreFundAudit.do',
        method: 'get',
        params   //【organizationId|userId|version|auditId】
    })
}

/*--------------------------------------装介绍列表查看----------------------------------------- */
export const gainOrganizationCustomerList = params => {     //-----获取装介绍用户列表-----//
    return axios({
        url: '/third/gainOrganizationCustomerList.do',
        method: 'get',
        params   //【organizationId|userId|version|orderStatus：1,2,3|appType:"znz"】
    })
}

export const setStatus = params => {     //-----设置跟进状态-----//
    return axios({
        url: '/third/setOrganizationCustomerStatus.do',
        method: 'get',
        params   //【organizationId|userId|version|id】
    })
}


/*--------------------------------------调整公司设置----------------------------------------- */

// 1.设置公司名称和logo

export const gainCompanyName = params => {    //-----获取当前公司名称-----//
    return axios({
        url: '/set/gainCompanyName.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

export const setCompanyName = params => {     //-----设置当前公司名称-----//
    return axios({
        url: '/set/setCompanyName.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationName 】
    })
}

export const gainCompanyLogo = params => {     //-----获取当前公司的logo图片-----//
    return axios({
        url: '/set/gainCompanyLogo.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}
export const updateCompanyLogo = params => {     //-----设置当前公司的logo图片-----//
    return axios({
        url: '/set/updateCompanyLogo.do',
        method: 'get',
        params   //【organizationId|userId|version|logo 】
    })
}

//  2.设置成员角色  

// export const gainEmployeeType = params => {     //-----获取成员角色列表-----//
//     return axios({
//         url: '/set/gainEmployeeType.do',
//         method: 'get',
//         params   //【 organizationId|userId|version 】
//     })
// }

/**
 * @name  获取成员角色列表
 * @param {organizationId,userId,version,organizationScheduleId} params 
 */
export const gainEmployeeRole = (params) => Post(params, '/set/gainEmployeeRole.do');



export const addEmployeeType = params => {     //----添加成员角色-----//
    return axios({
        url: '/set/addEmployeeType.do',
        method: 'get',
        params   //【 organizationId|userId|version|roleName 】
    })
}

export const editEmployeeType = params => {     //-----编辑成员角色-----//
    return axios({
        url: '/set/editEmployeeType.do',
        method: 'get',
        params   //【organizationId|userId|version|roleName|organizationRoleId】
    })
}

export const delEmployeeType = params => {     //-----删除成员角色-----//
    return axios({
        url: '/set/delEmployeeType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationRoleId 】
    })
}

export const setOrganizationRolePrev = params => {     //-----成员角色排序-----//
    return axios({
        url: '/v2/set/setOrganizationRolePrev.do',
        method: 'get',
        params   //【organizationId|userId|version|currentId|beforeId 】
    })
}


// 3.设置装修类型

/**
  * @name  获取装修类型列表
  * @param {organizationId,userId,version} params 
  */
export const gainDecorateType = (params) => Get(params, '/set/gainDecorateType.do');

/**
  * @name  添加装修类型
  * @param {organizationId,userId,version,decorateName} params 
  */
export const addDecorateType = (params) => Get(params, '/set/addDecorateType.do');



export const editDecorateType = params => {     //-----编辑装修类型-----//
    return axios({
        url: '/set/editDecorateType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationDecorateId|decorateName 】
    })
}

export const delDecorateType = params => {     //-----删除装修类型-----//
    return axios({
        url: '/set/delDecorateType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationDecorateId】
    })
}

// 4.设置款项构成

export const gainContractType = params => {     //-----获取款项构成列表-----//
    return axios({
        url: '/set/gainContractType.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

export const addContractType = params => {     //----添加款项构成-----//
    return axios({
        url: '/set/addContractType.do',
        method: 'get',
        params   //【 organizationId|userId|version|name 】
    })
}

export const editContractType = params => {     //-----编辑款项构成-----//
    return axios({
        url: '/set/editContractType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationContractId|organizationContractName】
    })
}

export const delContractType = params => {     //-----删除款项构成-----//
    return axios({
        url: '/set/delContractType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationContractId 】
    })
}

export const setOrganizationContractPrev = params => {     //-----款项构成排序-----//
    return axios({
        url: '/v2/set/setOrganizationContractPrev.do',
        method: 'get',
        params   //【organizationId|userId|version|currentId|beforeId】
    })
}


// 5.设置收款状态

export const gainFundType = params => {     //-----获取收款状态列表-----//
    return axios({
        url: '/set/gainFundType.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

export const addFundType = params => {     //----添加收款状态-----//
    return axios({
        url: '/set/addFundType.do',
        method: 'get',
        params   //【organizationId|userId|version|fundName 】
    })
}

export const editFundType = params => {     //-----编辑收款状态-----//
    return axios({
        url: '/set/editFundType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationFundId|fundName 】
    })
}

export const delFundType = params => {     //-----删除收款状态-----//
    return axios({
        url: '/set/delFundType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationFundId 】
    })
}

export const setOrganizationFundPrev = params => {     //-----收款状态排序-----//
    return axios({
        url: '/v2/set/setOrganizationFundPrev.do',
        method: 'get',
        params   //【organizationId|userId|version|currentId|beforeId】
    })
}


// 6.设置渠道来源

/**
  * @name  获取渠道来源列表
  * @param {organizationId,userId,version} params 
  */
export const gainChannelSource = (params) => Get(params, '/set/gainChannelSource.do');

/**
 * @name  添加渠道来源
 * @param {organizationId,userId,version} params 
 */
export const addChannelSource = (params) => Get(params, '/set/addChannelSource.do');


export const editChannelSource = params => {     //-----编辑渠道来源-----//
    return axios({
        url: '/set/editChannelSource.do',
        method: 'get',
        params   //【 organizationId|userId|version|organizationChannelsourceId|channelsourceName 】
    })
}

export const delChannelSource = params => {     //-----删除渠道来源-----//
    return axios({
        url: '/set/delChannelSource.do',
        method: 'get',
        params   //【 organizationId|userId|version|organizationChannelsourceId 】
    })
}

export const setOrganizationChannelSourcePrev = params => {     //-----渠道来源排序-----//
    return axios({
        url: '/v2/set/setOrganizationChannelSourcePrev.do',
        method: 'get',
        params   //【 organizationId|userId|version|currentId|beforeId】
    })
}

// 7.设置建材支出分类

export const gainRecordType = params => {     //-----获取建材支出分类列表-----//
    return axios({
        url: '/v2/set/gainRecordType.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

export const addRecordType = params => {     //----添加建材支出分类-----//
    return axios({
        url: '/v2/set/addRecordType.do',
        method: 'get',
        params   //【organizationId|userId|version|recordTypeName 】
    })
}

export const updateRecordType = params => {     //-----编辑建材支出分类-----//
    return axios({
        url: '/v2/set/updateRecordType.do',
        method: 'get',
        params   //【organizationId|userId|version|typeId|recordTypeName 】
    })
}

export const delRecordType = params => {     //-----删除建材支出分类-----//
    return axios({
        url: '/v2/set/delRecordType.do',
        method: 'get',
        params   //【organizationId|userId|version|typeId 】
    })
}

// 8.设置内控权限

export const gainOrganizatioProjectVisual = params => {     //-----内控权限状态-----//
    return axios({
        url: '/set/gainOrganizatioProjectVisual.do',
        method: 'get',
        params   //【organizationId|userId|version】
    })
}

export const setOrganizatioProjectVisual = params => {     //-----设置内控权限-----//
    return axios({
        url: '/set/setOrganizatioProjectVisual.do',
        method: 'get',
        params   //【organizationId|userId|version|isVisible 】isVisible:true false
    })
}

// 9.完成进度必须上传图片

export const gainProjectScheduleMustPicSocket = params => {     //-----获取完成进度必须上传图片进度-----//
    return axios({
        url: '/v2/set/gainProjectScheduleMustPicSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

export const switchProjectScheduleMustPic = params => {     //-----完成进度必须上传图片-----//
    return axios({
        url: '/v2/set/switchProjectScheduleMustPic.do',
        method: 'get',
        params   //【organizationId|userId|version|mustPic 】 mustPic:0 1,
    })
}


//10.允许业主查看进度标准

export const gainCustomerScheduleStandardSocket = params => {     //-----查看允许业主查看进度标准状态-----//
    return axios({
        url: '/v2/set/gainCustomerScheduleStandardSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】    
    })
}

export const setCustomerScheduleStandardSocket = params => {     //-----修改允许业主查看进度标准-----//
    return axios({
        url: '/v2/set/setCustomerScheduleStandardSocket.do',
        method: 'get',
        params   //【organizationId|userId|version|socket 】 socket：0 1    
    })
}

//11.完工检查开关

export const getProjectOverSocket = params => {     //----查看完工检查开关-----//
    return axios({
        url: '/v3/set/getProjectOverSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

export const setProjectOverSocket = params => {     //----设置完工检查开关-----//
    return axios({
        url: '/v3/set/setProjectOverSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

//12.完工检查开关

export const getIsShowPhoneSocket = params => {     //----查看是否显示公司成员手机号码状态-----//
    return axios({
        url: '/v3/set/getIsShowPhoneSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

export const switchIsShowPhoneSocket = params => {     //----设置是否显示公司成员手机号码-----//
    return axios({
        url: '/v3/set/switchIsShowPhoneSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

export const getIsShowSignInSocket = params => {     //----查看是否允许业主查看签到记录状态-----//
    return axios({
        url: '/v3/set/getIsShowSignInSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}


export const switchIsShowSignInSocket = params => {     //----设置是否允许业主查看签到记录-----//
    return axios({
        url: '/v3/set/switchIsShowSignInSocket.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}



//13.设置项目模板

/**
 * @name  获取项目列表
 * @param {organizationId,userId,version} params 
 */
export const getTemplateInfo = (params) => Get(params, '/v2/set/getTemplateInfo.do');




export const addOrganizationScheduleTemplate = params => {     //----添加项目模板-----//
    return axios({
        url: '/v2/set/addOrganizationScheduleTemplate.do',
        method: 'get',
        params   //【organizationId|userId|version|templateName|templateId】
    })
}

export const editOrganizationScheduleTemplateName = params => {     //-----编辑项目模板-----//
    return axios({
        url: '/v2/set/editOrganizationScheduleTemplateName.do',
        method: 'get',
        params   //【organizationId|userId|version|templateId|templateName 】
    })
}

export const delOrganizationScheduleTemplate = params => {     //-----删除项目模板-----//
    return axios({
        url: '/v2/set/delOrganizationScheduleTemplate.do',
        method: 'get',
        params   //【organizationId|userId|version|templateId| 】
    })
}

export const setOrganizationScheduleTemplatePrev = params => {     //-----项目模板排序-----//
    return axios({
        url: '/v2/set/setOrganizationScheduleTemplatePrev.do',
        method: 'get',
        params   //【organizationId|userId|version|currentId|beforeId】
    })
}

export const gainScheduleType = params => {     //-----项目模板计划表-----//
    return axios({
        url: '/set/gainScheduleType.do',
        method: 'get',
        params   //【organizationId|userId|version|templateId 】
    })
}

export const addScheduleType = params => {     //-----添加进度名称-----// 
    return axios({
        url: '/set/addScheduleType.do',
        method: 'post',
        params   //【organizationId|userId|version|templateId |scheduleName |completedDays | chargeRoles|scheduleText】
    })
}

export const delScheduleType = params => {     //-----删除进度名称-----// 
    return axios({
        url: '/set/delScheduleType.do',
        method: 'post',
        params   //【organizationId|userId|version|organizationScheduleId 】
    })
}

export const editScheduleType = params => {     //-----编辑进度名称-----// 
    return axios({
        url: '/set/editScheduleType.do',
        method: 'post',
        params   //【organizationId|userId|version|organizationScheduleId|scheduleText|organizationScheduleName |templateId|chargeRoles】
    })
}

export const setOrganizationSchedulePrev = params => {     //-----排序进度名称-----// 
    return axios({
        url: '/v2/set/setOrganizationSchedulePrev.do',
        method: 'post',
        params
    })
}




/*--------------------------------------设置部门和员工----------------------------------------- */

export const showDepartInfo = params => {     //-----显示部门员工列表-----//
    return axios({
        url: '/v2/set/showDepartInfo.do',
        method: 'get',
        params   //【organizationId|userId|version 】
    })
}

export const addDepart = params => {     //-----添加部门名称-----//
    return axios({
        url: '/v2/set/addDepart.do',
        method: 'get',
        params   //【organizationId|userId|version departName】
    })
}


export const editDepart = params => {     //-----编辑部门名称-----//
    return axios({
        url: '/v2/set/editDepart.do',
        method: 'get',
        params   //【organizationId|userId|version departId departName】
    })
}

export const delDepart = params => {     //-----删除部门名称-----//
    return axios({
        url: '/v2/set/delDepart.do',
        method: 'get',
        params   //【organizationId|userId|version departId】
    })
}

export const setOrganizationDepartPrev = params => {     //-----部门排序-----//
    return axios({
        url: '/v2/set/setOrganizationDepartPrev.do',
        method: 'get',
        params   //【organizationId|userId|version currentOrganizationDepartId beforeOrganizationDepartId】
    })
}

export const setOrganizationMaster = params => {     //-----修改是否管理员-----//
    return axios({
        url: '/user/setOrganizationMaster.do',
        method: 'get',
        params   //【organizationId|userId|version setOrCancle sUserId】
    })
}

export const setDepartMaster = params => {     //-----修改是否部门主管-----//
    return axios({
        url: '/v2/set/setDepartMaster.do',
        method: 'get',
        params   //【organizationId|userId|version setOrCancle departId 】
    })
}



/*--------------------------------------设置广告启动页----------------------------------------- */


/**
  * @name  获取广告页图片
  * @param {organizationId,userId,version} params 
  */
export const getBootAdvertising = (params) => Get(params, '/v2/set/getBootAdvertising.do');

/**
  * @name  设置启动页的广告图片
  * @param {organizationId,userId,version,advertisement,expireTime,url} params 
  */
export const setBootAdvertising = (params) => Get(params, '/v2/set/setBootAdvertising.do');


/*--------------------------------------申请vip----------------------------------------- */

/**
  * @name  申请vip
  * @param {organizationId,userId,content,version} params 
  */
export const gainApplyInfo = (params) => Get(params, '/user/gainApplyInfo.do');

/*--------------------------------------意见反馈----------------------------------------- */

/**
  * @name  添加意见反馈
  * @param {organizationId,userId,type=1} params 
  */
 export const addSuggestions = (params) => Post(params, '/user/addSuggestions.do');

/*--------------------------------------设置建材库----------------------------------------- */

export const gainMaterialsType = params => {     //-----获取建材库列表-----//
    return axios({
        url: '/set/gainMaterialsType.do',
        method: 'get',
        params   //【organizationId|userId|version|qr】
    })
}

export const addMaterialsType = params => {     //-----添加建材库-----//
    return axios({
        url: '/set/addMaterialsType.do',
        method: 'get',
        params   //【organizationId|userId|version|materialsName 】
    })
}

export const editMaterialsType = params => {     //-----修改建材库-----//
    return axios({
        url: '/set/editMaterialsType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationMaterialsTypeId|materialsTypeName 】
    })
}

export const delMaterialsType = params => {     //-----删除建材库-----//
    return axios({
        url: '/set/delMaterialsType.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationMaterialsTypeId 】
    })
}

export const gainNMaterialsBrand = params => {     //-----获取建材品牌列表-----//
    return axios({
        url: '/v3/set/gainNMaterialsBrand.do',
        method: 'get',
        params   //【organizationId|userId|version|materialsTypeId 】
    })
}

export const addNMaterialsBrand = params => {     //-----添加建材品牌-----//
    return axios({
        url: '/v3/set/addNMaterialsBrand.do',
        method: 'get',
        params   //【organizationId|userId|version|materialsTypeId|brandName 】
    })
}



export const editNMaterialsBrand = params => {     //-----修改建材品牌-----//
    return axios({
        url: '/v3/set/editNMaterialsBrand.do',
        method: 'get',
        params   //【organizationId|userId|version|brandName|brandId|materialsTypeId 】
    })
}

export const delMaterialsBrand = params => {     //-----删除建材品牌-----//
    return axios({
        url: '/set/delMaterialsBrand.do',
        method: 'get',
        params   //【organizationId|userId|version|organizationMaterialsBrandId|materialsTypeId 】
    })
}


export const gainMaterialsBuilding = params => {     //-----获取建材型号-----//
    return axios({
        url: '/v3/set/gainMaterialsBuilding.do',
        method: 'get',
        params   //【organizationId|userId|version|materialsBrandId 】
    })
}

export const addBuildingNum = data => {     //-----添加建材型号-----//
    return axios({
        url: '/v3/set/addBuildingNum',
        method: 'post',
        data   //【organizationId|userId|version|materialsTypeId|materialsBrandId|buildingName|price|priceUnit|customCode|photo|remark|salePrice|detailsPhoto 】
    })
}

export const editMaterialsBuilding = data => {     //-----编辑建材型号-----//
    return axios({
        url: '/v3/set/editMaterialsBuilding',
        method: 'post',
        data   //【organizationId|userId|version|materialsTypeId|materialsBrandId|buildingName|buildingId|supplyPrice|supplyUnit|customCode|photo|remark|salePrice|detailsPhoto 】
    })
}

export const delMaterialsBuilding = params => {     //-----删除建材型号-----//
    return axios({
        url: '/v3/set/delMaterialsBuilding.do',
        method: 'get',
        params   //【 organizationId|userId|version|buildingId 】
    })
}

















/**
  * @name  获取建材单位列表
  * @param {organizationId,userId,version} params 
  */
export const gainMaterialsBrandUnit = (params) => Get(params, '/v2/set/gainMaterialsBrandUnit.do');

/*--------------------------------------公用接口----------------------------------------- */
// export const addOssPhoto = data => {      //-----上传图片接口-----// 
//     return axios({
//         url: '/image/addOssPhoto.do',
//         method: 'post',
//         // headers:{
//         //     'Content-Type':'application/x-www-form-urlencoded'
//         // },

//         data  //【new FormData()的相关对象】let files = this.$refs.file.files[0]; let fd = new FormData(); fd.append("files", files)
//     })
// }

export const addOssPhoto = (data) => Post(data, '/image/addOssPhoto.do');  //【 usermobile,userpassword 】 


export const gainNotFloweCustomerCount = params => {      //-----没有处理的装介绍客户数量-----// 
    return axios({
        url: '/v2/set/gainNotFloweCustomerCount.do',
        method: 'get',
        params  //【 organizationId|userId|version 】
    })
}

/**
  * @name  获取装内助的版本号
  * @param {type:android,appType:znz} params 
  */
export const gainlatestVersion = (params) => Get(params, '/user/gainlatestVersion.do');














// WEBPACK FOOTER //
// ./src/api/api.js